import { AngularFireStorageModule } from '@angular/fire/storage';

import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExternoRoutingModule } from './externo-routing.module';
import { FormsModule } from '@angular/forms';
import { ImageCropperModule } from 'ngx-image-cropper';

import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { CalendarModule } from 'angular-calendar';
import { DateAdapter } from 'angular-calendar';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs);
import { NgxPaginationModule } from 'ngx-pagination';

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { ReactiveFormsModule } from '@angular/forms';

import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { DatetimePopupModule } from 'ngx-bootstrap-datetime-popup';

import { TranslateModule } from '@ngx-translate/core';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { ProfileComponent } from './profile/profile.component';
import { AjustesComponent } from './profile/ajustes/ajustes.component';
import { EventosComponent } from './profile/eventos/eventos.component';
import { FotoComponent } from './profile/foto/foto.component';
import { MisalaComponent } from './profile/misala/misala.component';
import { PassComponent } from './profile/pass/pass.component';
import { ManualComponent } from './manual/manual.component';
import { AppsInternasComponent } from './home/apps-internas/apps-internas.component';
import { LiveComponent } from './home/live/live.component';
import { UserboxComponent } from './home/userbox/userbox.component';
import { ExternoComponent } from './externo.component';
import { FilterAppExternoPipe } from '../pipes/filter-app-externo.pipe';
import { CalendarComponent } from './calendar/calendar.component';
import { Search3Pipe } from '../pipes/search3.pipe';
import { NoaccesibleComponent } from './noaccesible/noaccesible.component';

@NgModule({
  declarations: [
    MenuComponent,
    ExternoComponent,
    HomeComponent,
    HeaderComponent,
    ProfileComponent,
    AjustesComponent,
    EventosComponent,
    FotoComponent,
    MisalaComponent,
    PassComponent,
    ManualComponent,
    AppsInternasComponent,
    LiveComponent,
    FilterAppExternoPipe,
    Search3Pipe,
    UserboxComponent,
    CalendarComponent,
    NoaccesibleComponent,
  ],
  imports: [
    TimepickerModule,
    DatetimePopupModule,
    CommonModule,
    ExternoRoutingModule,
    FormsModule,
    ImageCropperModule,
    AngularFireStorageModule,
    NgbModalModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NgxPaginationModule,
    NgxMaterialTimepickerModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'es-ES' }],
})
export class ExternoModule {}
